import { httpsCallable } from "firebase/functions";
import { functions } from "./firebase";

export const getWorkflows = async () => {
  try {
    if (!functions) {
      throw new Error("Firebase functions not initialized");
    }
    const workflowServiceCallable = httpsCallable<unknown, any>(functions, 'workflowService');
    const result = await workflowServiceCallable({
      action: "getWorkflows",
      data: {}
    });
    let data = result.data;
    if (Array.isArray(data)) {
      return data;
    }
    if (data && typeof data === 'object') {
      if (Array.isArray(data.workflows)) return data.workflows;
      if (Array.isArray(data.data)) return data.data;

      const values = Object.values(data);
      if (values.length > 0 && values.every(v => v && typeof v === 'object')) {
        return values;
      }
    }
    return [];
  } catch (error) {
    console.error('Error fetching workflows:', error);
    throw error;
  }
};

export const getWorkflowById = async (id: string) => {
  try {
    if (!functions) {
      throw new Error("Firebase functions not initialized");
    }
    const workflowServiceCallable = httpsCallable<unknown, any>(functions, 'workflowService');
    const result = await workflowServiceCallable({
      action: "getWorkflowById",
      data: { id }
    });
    return result.data;
  } catch (error) {
    console.error('Error fetching workflow:', error);
    throw error;
  }
};
